import React, { useState } from 'react';
import NxtbnModal from '../../components/Modal';
import useApi from "../../api";
import { useDispatch } from 'react-redux';
import { fetchRecursiveCategories } from "../../redux/categoriesSlice";
import { getQueryVariables } from '../../utils';
import { useSearchParams } from 'react-router-dom';

interface CategoryModalProps {
  isOpen: boolean;
  onClose: () => void;
  refresh: () => void;
}

function CategoryModal({ isOpen, onClose, refresh }: CategoryModalProps) {
  const [searchParams, setSearchParams] = useSearchParams();
  const queryparams = getQueryVariables(searchParams);
  const [formData, setFormData] = useState({parent: queryparams.parent})

  const api = useApi();
  const dispatch = useDispatch()

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    api.createCategory(formData).then((response: any) => {
      refresh();
      dispatch(fetchRecursiveCategories() as any);
    }, (error) => {

    });

    onClose();
  };

  const handleChange = (e: any) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };



  return (
    <NxtbnModal isOpen={isOpen} onClose={onClose}>
      <form onSubmit={(e) => { e.stopPropagation(); handleSubmit(e); }} className="p-6">
        <h2 className="text-lg font-medium text-gray-900"> {queryparams.parent ? `Add Subcategory for ${queryparams.parentName}` : `Add Category`}</h2>
        <div className="mt-4">
          <label htmlFor="name" className="block text-sm font-medium text-gray-700">
            Name
          </label>
          <input
            type="text"
            id="name"
            name='name'
            onChange={handleChange}
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            required
          />
        </div>
        <div className="mt-4">
          <label htmlFor="description" className="block text-sm font-medium text-gray-700">
            Description
          </label>
          <textarea
            id="description"
            name='description'
            onChange={handleChange}
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            rows={4}
            required
          />
        </div>
        <div className="mt-6 flex justify-end">
          <button
            type="button"
            onClick={onClose}
            className="mr-3 text-[#0CAF60] border border-[#0CAF60] hover:bg-slate-200 text-sm font-medium rounded-md shadow-sm focus:ring-2 focus:ring-offset-2 focus:ring-gray-400 px-4 py-2 focus:outline-none sm:text-sm"
          >
            Cancel
          </button>
          <button
            type="submit"
            className="inline-flex justify-center rounded-md border border-transparent px-4 py-2 bg-primary-600 text-base font-medium text-white shadow-sm hover:bg-primary-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm"
          >
            Add
          </button>
        </div>
      </form>
    </NxtbnModal>
  );
}

export default CategoryModal;
